import { Link } from "react-router-dom";
import { socials } from "../constants";
import BafarLabs from "../assets/logow.png";
import { phone, location, mail } from "../assets";

const Footer = () => {
  const emailUser = "info";
  const emailDomain = "bafarlabs.com";
  return (
    <div className="flex w-full flex-col items-center justify-start border-t border-n-6 bg-n-8 px-5 py-10 text-white 2xl:px-10">
      {/* Top Section */}
      <div className="flex w-full flex-col items-start justify-center gap-6 pl-5 min-[835px]:flex-row min-[835px]:items-center min-[835px]:justify-between">
        {/* Logo */}
        <Link to="/#hero" className="w-[12rem]">
          <img src={BafarLabs} width={190} height={40} alt="Bafarlabs Logo" />
        </Link>

        {/* Contact Information - Change layout for md and larger */}
        <div className="flex flex-col items-start gap-2 min-[1250px]:flex-row min-[1250px]:items-center xl:gap-6 2xl:gap-10">
          <a
            href={`mailto:${emailUser}@${emailDomain}`}
            rel="nofollow"
            className="flex items-center gap-2 text-neutral-400 hover:text-white"
          >
            <img src={mail} alt="email" className="h-6 w-6" />
            {emailUser}@{emailDomain}
          </a>
          <a
            href="tel:+919539642647"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-neutral-400 hover:text-white"
          >
            <img src={phone} alt="phone" className="h-6 w-6" />
            +91 95396 42647
          </a>
          <a
            href="https://maps.app.goo.gl/xFrrrDmf5vSr68mE8"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-neutral-400 hover:text-white"
          >
            <img src={location} alt="location" className="h-6 w-6" />
            <span>Kozhikode, India</span>
            <span>|</span>
            <span>Doha, Qatar</span>
          </a>
        </div>

        {/* Social Media Links */}
        <ul
          className="mt-4 flex gap-3 md:mt-0"
          role="list"
          aria-label="Social media links"
        >
          {socials.slice(0, 4).map((item) => (
            <li key={item.id} role="listitem">
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-n-7 transition-colors hover:bg-n-6"
              >
                <img
                  src={item.iconUrl}
                  alt={`Icon for ${item.title}`}
                  width={16}
                  height={16}
                />
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Bottom Section */}
      <div className="mt-6 w-full border-t border-gray-700 pt-4 text-center">
        {/* Links to Privacy Policy and Terms & Conditions */}
        <div className="mb-4 text-neutral-400">
          <Link to="/privacy-policy" className="mr-4 hover:text-white">
            Privacy Policy
          </Link>
          {" | "}
          <Link to="/terms-and-conditions" className="ml-4 hover:text-white">
            Terms and Conditions
          </Link>
        </div>

        <p className="text-sm text-neutral-400">
          © {new Date().getFullYear()} Bafar Labs. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
